import React from 'react';
import type { RevenueDynamicsProduct } from './revenueDynamicsMeta';
import { RevenueDynamicsProductPickerView } from './RevenueDynamicsProductPickerView';
import { useRevenueDynamicsProductPicker } from './useRevenueDynamicsProductPicker';

type RevenueDynamicsProductPickerProps = {
    productId: string | null;
    setProductId: (id: string | null) => void;
    products: ReadonlyArray<RevenueDynamicsProduct>;
};

/**
 * Searchable product filter for the chart. Container wires
 * {@link useRevenueDynamicsProductPicker} (open state, grouping, select/clear)
 * into the render-only `RevenueDynamicsProductPickerView`.
 */
export const RevenueDynamicsProductPicker: React.FC<
    RevenueDynamicsProductPickerProps
> = ({ productId, setProductId, products }) => {
    const vm = useRevenueDynamicsProductPicker(
        productId,
        setProductId,
        products,
    );

    return <RevenueDynamicsProductPickerView {...vm} />;
};
